import { idtype, image } from "querypieces";

export default `
  ...on pageBuilder_waveTextOnBackgroundImage_BlockType {
    ${idtype}
    plainText
    ${image}
  }
`
